import { DatePipe, formatDate } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import moment, { Moment } from 'moment';
import { BehaviorSubject, combineLatest, Observable, of, Subscription } from 'rxjs';
import { filter, map, shareReplay, startWith, switchMap, tap } from 'rxjs/operators';
import { ConstructionDiaryEntity, ConstructionDiaryStatusEnum } from '../../../../dave-data-module/entities/construction-diary.entity';
import { EventTypeNamesEnum } from '../../../../dave-data-module/entities/event-type.entity';
import { EventEntity } from '../../../../dave-data-module/entities/event.entity';
import { GeneratedDocumentsTypeSlugs, GeneratedDocumentsTypeSlugsForDiary } from '../../../../dave-data-module/entities/generatedDocumentsType.entity';
import { GeneratedDocumentsResolver } from '../../../../dave-data-module/guards/generatedDocuments.resolver';
import { GeneratedDocumentsTypeResolver } from '../../../../dave-data-module/guards/generatedDocumentsType.resolver';
import { TextTemplateLanguageResolver } from '../../../../dave-data-module/guards/text-template-language.resolver';
import { UserToEventResolver } from '../../../../dave-data-module/guards/user-to-event.resolver';
import { FrontendDate } from '../../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { State } from '../../../../dave-data-module/State';
import { getEventTypeFetched, getEventTypes } from '../../../../dave-data-module/State/selectors/event-type.selector';
import { getUserToEventFetched } from '../../../../dave-data-module/State/selectors/user-to-event.selector';
import { appMatDialogDefaultConfig, isNotNullOrUndefined, sameDay, TableColumnConfig } from '../../../../helper/helper';
import { CustomLabelService } from '../../../../services/custom-label/custom-label.service';
import { DiaryDataService } from '../../../../services/diary-data.service';
import { LoadingService } from '../../../../services/loading.service';
import { GeneratedDocumentsType } from '../../../../dave-data-module/graphql-types';
import { defaultResizePixel, getExportOptions, imageQualityEnum, imageQualityOptions } from '../diary-export.helper';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { FILTER_TYPE_SEARCH_MULTI_SELECT, IFilterTypeSearchMultiSelectValue } from 'src/app/dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { FilterTypes } from 'src/app/services/default-filter.service';
import { selectEventCategories, selectEventCategoriesFetched } from 'src/app/dave-data-module/State/selectors/event-Categories.selector';
import { EventCategoriesActionTypes } from 'src/app/dave-data-module/State/actions/event-categories.actions';
import { EventCategoriesEntity } from 'src/app/dave-data-module/entities/event-categories.entity';
import { CategoriesWithAssignments } from 'src/app/dave-data-module/services/event-categories.service-data-service';
import { Event2EventCategoriesEntity } from 'src/app/dave-data-module/entities/event-to-event-catgories.entity';
import { MatSort } from '@angular/material/sort';
import { getFetched$ } from '../../../../dave-data-module/helper/helper';
import {
    getConstructionDiariesByCommissionId
} from '../../../../dave-data-module/State/selectors/construction-diary.selectors';
import { EventDataService } from '../../../../dave-data-module/services/event.service-data-service';

export type SelectDiaryTimespanDialogComponentDialogReturnData =  GeneratedDocumentsType[] | undefined;
export interface SelectDiaryTimespanDialogComponentDialogData {
    CommissionId: number;
    DiaryType?: GeneratedDocumentsTypeSlugsForDiary;
    DateFormDefaultValue?: Date;
    ToDateFormDefaultValue?: Date;
}
interface TableData {
    checkbox?: string;
    id: number;
    eventNumber: string;
    name: string;
    eventDate: string;
    eventDateAsMillis: number;
    categorie: string;
    categorieIds: number[];
}
@Component({
    selector: 'app-select-diary-timespan-dialog',
    templateUrl: './select-diary-timespan-dialog.component.html',
    styleUrls: ['./select-diary-timespan-dialog.component.scss'],
    providers: [DatePipe],
})
export class SelectDiaryTimespanDialogComponent implements OnInit, OnDestroy {
    @ViewChild(MatSort) sort: MatSort;
    static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
    };
    public readonly defaultResizePixel = defaultResizePixel;
    private today = () => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    };
    public TableColumns: TableColumnConfig<TableData>[] = [
        { header: 'Nummer', name: 'eventNumber' },
        { header: 'Name', name: 'name' },
        { header: 'Datum', name: 'eventDate' },
        { header: 'Kategorie', name: 'categorie' },
    ];
    FormGroup = new FormGroup(
        {
            from: new FormControl<Moment | null>(moment(this.today()), Validators.required),
            to: new FormControl<Moment | null>(moment(this.today()), Validators.required),
            zusatzarbeiten: new FormControl<boolean | null>(false),
            dokumentation: new FormControl<boolean | null>(false),
            regiearbeit: new FormControl<boolean | null>(false),
            auffaelligkeiten: new FormControl<boolean | null>(false),
            bedenken: new FormControl<boolean | null>(false),
            mangel: new FormControl<boolean | null>(false),
            erschwernis: new FormControl<boolean | null>(false),
            bautagebuch: new FormControl<boolean | null>(true),
            exportWorkTimes: new FormControl<boolean | null>(true),
            showFooter: new FormControl<boolean | null>(false),
            imageColCount: new FormControl<1|2|3>(1),
            imageMinRowCount: new FormControl<1|2|3>(1),
            imageQuality: new FormControl<imageQualityEnum>(imageQualityEnum.default),
            imageQualityPX: new FormControl<number | null>(null),
        },
        (group) => {
            return group.value.zusatzarbeiten || group.value.bautagebuch || group.value.bedenken || group.value.auffaelligkeiten || group.value.mangel || group.value.erschwernis || group.value.dokumentation || group.value.regiearbeit ? null : { nothingToExport: { value: group.value } };
        },
    );
    protected readonly imageQualityOptions = imageQualityOptions
    public DateForm = this.FormGroup.controls.from;
    public ToDateForm = this.FormGroup.controls.to;
    public Diaries: ConstructionDiaryEntity[];
    private subs: Subscription[] = [];
    private diaries$: Observable<ConstructionDiaryEntity[]>;
    private nachnahmenFromCommission$: Observable<EventEntity[]>;
    private dokumentationFromCommission$: Observable<EventEntity[]>;
    private regiearbeitFromCommission$: Observable<EventEntity[]>;
    private auffaelligkeitenFromCommission$: Observable<EventEntity[]>;
    private mangelFromCommission$: Observable<EventEntity[]>;
    private erschwernisFromCommission$: Observable<EventEntity[]>;
    private bedenkenFromCommission$: Observable<EventEntity[]>;
    private nachnahmenFromCommission: EventEntity[];
    private auffaelligkeitenFromCommission: EventEntity[];
    private dokumentationFromCommission: EventEntity[];
    private regiearbeitFromCommission: EventEntity[];
    private mangelFromCommission: EventEntity[];
    private erschwernisFromCommission: EventEntity[];
    private bedenkenFromCommission: EventEntity[];
    public DiaryCount$: Observable<number>;
    /*
    public NachnahmenCount$: Observable<number>;
    public DokumentationCount$: Observable<number>;
    public RegiearbeitCount$: Observable<number>;
    public AuffaelligCount$: Observable<number>;
    public BedenkenCount$: Observable<number>;
    public MangelCount$: Observable<number>;
    public ErschwernisCount$: Observable<number>;
    */
    public availableColumns: Array<keyof TableData> = ['checkbox', 'eventNumber', 'name', 'categorie', 'eventDate'];
    public displayedColumns: Array<keyof TableData> = [...this.availableColumns];
    public selection = new SelectionModel<TableData>(true, []);
    public DataSource$: Observable<MatTableDataSource<TableData>>;
    private eventCategories$: Observable<CategoriesWithAssignments> = this.store.select(selectEventCategoriesFetched).pipe(
        tap((fetched) => {
            if (!fetched) {
                this.store.dispatch(EventCategoriesActionTypes.Load({ Payload: {} }));
            }
        }),
        filter((fetched) => !!fetched),
        switchMap(() => this.store.select(selectEventCategories)),
        map((categories) =>
             categories
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public FilterValues$ = new BehaviorSubject<{
        [FilterTypes.EventCategory]: IFilterTypeSearchMultiSelectValue<number>[]
    }> ({
        [FilterTypes.EventCategory]: []
    });
    FilterSettings$ = this.eventCategories$.pipe(
        map((categories) => {
            return [
                {
                    Name: FilterTypes.EventCategory,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Kategorie',
                    Icon: null,
                    Values: categories.EventCategories.map<IFilterTypeSearchMultiSelectValue>((c) => ({ id: c.Id, label: c.Name })),
                },
            ];
        }),
    );
    public FilterAmount$ = this.FilterValues$.pipe(map((filter) => {
        let count = 0;
        if (filter[FilterTypes.EventCategory]?.length) {
            count++;
        }
        return count || null;
    }));
    constructor(
        private store: Store<State>,
        @Inject(MAT_DIALOG_DATA)
        public DialogData: SelectDiaryTimespanDialogComponentDialogData,
        private dialogRef: MatDialogRef<SelectDiaryTimespanDialogComponent, SelectDiaryTimespanDialogComponentDialogReturnData>,
        public LS: LoadingService,
        u2eResolver: UserToEventResolver,
        langRes: TextTemplateLanguageResolver,
        generatedDocumentsTypeResolver: GeneratedDocumentsTypeResolver,
        private generatedDocumentsResolver: GeneratedDocumentsResolver,
        protected cls: CustomLabelService,
        private diaryService: DiaryDataService,
        private eventDataService: EventDataService
    ) {
        langRes.resolve();
        u2eResolver.resolve();
        generatedDocumentsTypeResolver.resolve();
        if (DialogData.DateFormDefaultValue) {
            this.DateForm.setValue(moment(DialogData.DateFormDefaultValue));
        }
        if (DialogData.ToDateFormDefaultValue) {
            this.ToDateForm.setValue(moment(DialogData.ToDateFormDefaultValue));
        }
    }
    DateClass = (d: Moment): MatCalendarCellCssClasses => {
        const date = d.toDate();

        if (this.FormGroup.controls.zusatzarbeiten.value && this.nachnahmenFromCommission?.some((e) => sameDay(e.EventDate, date))) {
            return 'mat-datepicker-yellow';
        } else if (this.FormGroup.controls.dokumentation.value && this.dokumentationFromCommission?.some((e) => sameDay(e.EventDate, date))) {
            return 'mat-datepicker-yellow';
        } else if (this.FormGroup.controls.regiearbeit.value && this.regiearbeitFromCommission?.some((e) => sameDay(e.EventDate, date))) {
            return 'mat-datepicker-yellow';
        } else if (this.FormGroup.controls.auffaelligkeiten.value && this.auffaelligkeitenFromCommission?.some((e) => sameDay(e.EventDate, date))) {
            return 'mat-datepicker-yellow';
        } else if (this.FormGroup.controls.bedenken.value && this.bedenkenFromCommission?.some((e) => sameDay(e.EventDate, date))) {
            return 'mat-datepicker-yellow';
        } else if (this.FormGroup.controls.mangel.value && this.mangelFromCommission?.some((e) => sameDay(e.EventDate, date))) {
            return 'mat-datepicker-yellow';
        } else if (this.FormGroup.controls.erschwernis.value && this.erschwernisFromCommission?.some((e) => sameDay(e.EventDate, date))) {
            return 'mat-datepicker-yellow';
        } else if (this.FormGroup.controls.bautagebuch.value) {
            const diary = this.Diaries.find((d) => sameDay(d.Date, date));
            return diary?.GeneratedFileId ? 'mat-datepicker-blue' : diary?.Status === ConstructionDiaryStatusEnum.Newly ? 'mat-datepicker-yellow' : diary?.Status === ConstructionDiaryStatusEnum.Done ? 'mat-datepicker-green' : '';
        }
        return '';
    };
    ngOnDestroy(): void {
        this.subs.forEach((s) => s.unsubscribe());
    }

    ngOnInit(): void {
        if (this.DialogData.DiaryType) {
            this.FormGroup.controls.bautagebuch.setValue(this.DialogData.DiaryType === GeneratedDocumentsTypeSlugs.constructionDiary);
            this.FormGroup.controls.zusatzarbeiten.setValue(this.DialogData.DiaryType === GeneratedDocumentsTypeSlugs.zusatzarbeit);
            this.FormGroup.controls.bedenken.setValue(this.DialogData.DiaryType === GeneratedDocumentsTypeSlugs.bedenken);
            this.FormGroup.controls.mangel.setValue(this.DialogData.DiaryType === GeneratedDocumentsTypeSlugs.mangel);
            this.FormGroup.controls.erschwernis.setValue(this.DialogData.DiaryType === GeneratedDocumentsTypeSlugs.erschwernis);
            this.FormGroup.controls.auffaelligkeiten.setValue(this.DialogData.DiaryType === GeneratedDocumentsTypeSlugs.auffaelligkeit);
            this.FormGroup.controls.dokumentation.setValue(this.DialogData.DiaryType === GeneratedDocumentsTypeSlugs.dokumentation);
            this.FormGroup.controls.regiearbeit.setValue(this.DialogData.DiaryType === GeneratedDocumentsTypeSlugs.regiearbeit);
        }
        const eventsByTypeByCommissionId$ = (eventTypeName: EventTypeNamesEnum, commissonId: number) =>
            combineLatest([this.eventDataService.GetFromCommission$(commissonId).pipe(map(events => this.eventDataService.FilterEvents(events))), getFetched$(this.store, getEventTypeFetched, getEventTypes)]).pipe(
                map(([events, types]) => {
                    const type = types?.find((e) => e.Name === eventTypeName);
                    if (!type) {
                        // throw new Error(`Event type ${eventTypeName} not found`);
                        return [];
                    }
                    return events?.filter((e) => e.EventTypeId === type.Id);
                }),
                shareReplay({ refCount: true, bufferSize: 1 }),
            );
        this.nachnahmenFromCommission$ = eventsByTypeByCommissionId$(EventTypeNamesEnum.Zusatzarbeit, this.DialogData.CommissionId);
        this.dokumentationFromCommission$ = eventsByTypeByCommissionId$(EventTypeNamesEnum.Dokumentation, this.DialogData.CommissionId);
        this.regiearbeitFromCommission$ = eventsByTypeByCommissionId$(EventTypeNamesEnum.Regiearbeit, this.DialogData.CommissionId);
        this.auffaelligkeitenFromCommission$ = eventsByTypeByCommissionId$(EventTypeNamesEnum.Auffaeligkeit, this.DialogData.CommissionId);
        this.mangelFromCommission$ = eventsByTypeByCommissionId$(EventTypeNamesEnum.Mangelanzeige, this.DialogData.CommissionId);
        this.erschwernisFromCommission$ = eventsByTypeByCommissionId$(EventTypeNamesEnum.Erschwernis, this.DialogData.CommissionId);
        this.bedenkenFromCommission$ = eventsByTypeByCommissionId$(EventTypeNamesEnum.Bedenkenanzeige, this.DialogData.CommissionId);
        this.diaries$ =
             combineLatest([this.store.select(getConstructionDiariesByCommissionId(this.DialogData.CommissionId)), this.store.select(getUserToEventFetched).pipe(filter((v) => !!v))]).pipe(
             map(([diaries]) => diaries),
         );
        this.subs.push(
            this.diaries$.subscribe((d) => (this.Diaries = d)),
            this.nachnahmenFromCommission$.subscribe((d) => (this.nachnahmenFromCommission = d)),
            this.dokumentationFromCommission$.subscribe((d) => (this.dokumentationFromCommission = d)),
            this.regiearbeitFromCommission$.subscribe((d) => (this.regiearbeitFromCommission = d)),
            this.auffaelligkeitenFromCommission$.subscribe((d) => (this.auffaelligkeitenFromCommission = d)),
            this.mangelFromCommission$.subscribe((d) => (this.mangelFromCommission = d)),
            this.erschwernisFromCommission$.subscribe((d) => (this.erschwernisFromCommission = d)),
            this.bedenkenFromCommission$.subscribe((d) => (this.bedenkenFromCommission = d)),
        );
        this.DiaryCount$ = combineLatest([this.diaries$, this.ToDateForm.valueChanges.pipe(startWith('')), this.DateForm.valueChanges.pipe(startWith(''))]).pipe(
            map(([diaries]) => {
                if (this.DateForm.value && this.ToDateForm.value) {
                    const fromMoment = moment(new Date(FrontendDate(this.DateForm.value.toDate(), true)));
                    const toMoment = moment(new Date(FrontendDate(this.ToDateForm.value.toDate(), true)));
                    return diaries.filter((d) => moment(new Date(FrontendDate(d.Date, true))).isBetween(fromMoment, toMoment, undefined, '[]')).length;
                } else {
                    return 0;
                }
            }),
            shareReplay({ bufferSize: 1, refCount: true }),
        );
        /*
        const eventCountFromForm = (events$: Observable<EventEntity[]>) =>
            combineLatest([events$, this.ToDateForm.valueChanges.pipe(startWith('')), this.DateForm.valueChanges.pipe(startWith(''))]).pipe(
                map(([nachnahmen]) => {
                    if (this.DateForm.value && this.ToDateForm.value) {
                        const fromMoment = moment(new Date(FrontendDate(this.DateForm.value.toDate(), true)));
                        const toMoment = moment(new Date(FrontendDate(this.ToDateForm.value.toDate(), true)));
                        return nachnahmen.filter((d) => moment(new Date(FrontendDate(d.EventDate, true))).isBetween(fromMoment, toMoment, undefined, '[]')).length;
                    } else {
                        return 0;
                    }
                }),
                shareReplay({ bufferSize: 1, refCount: true }),
            );
        this.NachnahmenCount$ = eventCountFromForm(this.nachnahmenFromCommission$);
        this.DokumentationCount$ = eventCountFromForm(this.dokumentationFromCommission$);
        this.RegiearbeitCount$ = eventCountFromForm(this.regiearbeitFromCommission$);
        this.AuffaelligCount$ = eventCountFromForm(this.auffaelligkeitenFromCommission$);
        this.BedenkenCount$ = eventCountFromForm(this.bedenkenFromCommission$);
        this.MangelCount$ = eventCountFromForm(this.mangelFromCommission$);
        this.ErschwernisCount$ = eventCountFromForm(this.erschwernisFromCommission$);
        */
        this.DataSource$ = combineLatest([
            this.eventCategories$,
            this.ToDateForm.valueChanges.pipe(startWith('')),
            this.DateForm.valueChanges.pipe(startWith('')),
        ]).pipe(
            map(([eventCategories]) => {
                if (this.DateForm.value && this.ToDateForm.value && !(this.FormGroup.value.bautagebuch && this.Diaries)) {
                    let EventEntitys: EventEntity[][] = [];
                    let data: MatTableDataSource<TableData> = new MatTableDataSource<TableData>;
                    const fromMoment = moment(new Date(FrontendDate(this.DateForm.value.toDate(), true)));
                    const toMoment = moment(new Date(FrontendDate(this.ToDateForm.value.toDate(), true)));

                    if(this.FormGroup.value.zusatzarbeiten && this.nachnahmenFromCommission) {
                        EventEntitys.push(this.nachnahmenFromCommission);
                    }
                    if(this.FormGroup.value.dokumentation && this.dokumentationFromCommission) {
                        EventEntitys.push(this.dokumentationFromCommission);
                    }
                    if(this.FormGroup.value.regiearbeit && this.regiearbeitFromCommission) {
                        EventEntitys.push(this.regiearbeitFromCommission);
                    }
                    if(this.FormGroup.value.auffaelligkeiten && this.auffaelligkeitenFromCommission) {
                        EventEntitys.push(this.auffaelligkeitenFromCommission);
                    }
                    if(this.FormGroup.value.mangel && this.mangelFromCommission) {
                        EventEntitys.push(this.mangelFromCommission);
                    }
                    if(this.FormGroup.value.erschwernis && this.erschwernisFromCommission) {
                        EventEntitys.push(this.erschwernisFromCommission);
                    }
                    if(this.FormGroup.value.bedenken && this.bedenkenFromCommission) {
                        EventEntitys.push(this.bedenkenFromCommission);
                    }

                    if(EventEntitys) {
                        EventEntitys.forEach((events) => {
                            let selectedEvents = events.filter((e) => moment(new Date(FrontendDate(e.EventDate, true))).isBetween(fromMoment, toMoment, undefined, '[]'))
                            let result = selectedEvents
                                ? selectedEvents.map<TableData>((e) => {
                                    let categories2Event: Event2EventCategoriesEntity[] = eventCategories.Event2EventCategories.filter((e2ec) =>
                                        e.Id === e2ec.EventId
                                    )
                                    let categories2EventIds: number[] = categories2Event.map((c2e) =>
                                        c2e.CategoryId
                                    )
                                    let categorie: EventCategoriesEntity[] =  eventCategories.EventCategories.filter((ec) =>
                                        categories2EventIds.includes(ec.Id)
                                    )
                                    let categorieNames: string = '';
                                    let categorieIds: number[] = [];
                                    categorie.map((c, i, values) => {
                                        if (i === values.length - 1) {
                                        categorieNames += c.Name
                                        } else {
                                        categorieNames += c.Name + ', '
                                        }
                                        categorieIds.push(c.Id)
                                    })
                                    return {
                                        id: e.Id,
                                        eventNumber: e.EventNumber ?? e.Id.toString(),
                                        name: e.Name,
                                        eventDate: e?.EventDate ? formatDate(e.EventDate, 'dd.MM.yyyy', 'de-DE') : null,
                                        eventDateAsMillis: e?.EventDate ? e.EventDate.getTime() : null,
                                        categorie: categorieNames,
                                        categorieIds: categorieIds,
                                    }
                                }).filter(isNotNullOrUndefined)
                                : null;
                            result ? data.data.push(...result) : null
                        })
                    }
                    this.selection.clear();
                    return data
                }
                else {
                    return new MatTableDataSource<TableData>;
                }
            }),
            switchMap((dataSource) => {
                if (dataSource instanceof MatTableDataSource) {
                    dataSource.sort = this.sort;
                }
                let dataSourceData = dataSource.data.slice();
                return this.FilterValues$.pipe(
                    map((filter) => {
                        let filterdData = dataSourceData.slice();
                        if (filter[FilterTypes.EventCategory]?.length) {
                            filterdData = filterdData.filter((d) => filter[FilterTypes.EventCategory].some((f) => d.categorieIds.includes(f.id)));
                        }
                        dataSource.data = filterdData;
                        this.selection.selected.map((s) => {
                            filterdData.some((c) => c.id === s.id) ? null : this.selection.deselect(s);
                        })
                        return dataSource;
                    }),
                );
            }),
            tap((dataSource) =>
                (dataSource.sortingDataAccessor = (
                    object: TableData,
                    key: keyof  TableData,
                ): any | number => {
                    switch (key) {
                        case 'eventDate':
                            return object.eventDateAsMillis;
                        default:
                            return object[key];
                    }
                }),
            ),
        )
    }
    public Submit() {
        const typesToGenerate: GeneratedDocumentsTypeSlugsForDiary[] = [];
        if (this.FormGroup.value.bautagebuch) {
            typesToGenerate.push(GeneratedDocumentsTypeSlugs.constructionDiary);
        }
        if (this.FormGroup.value.zusatzarbeiten) {
            typesToGenerate.push(GeneratedDocumentsTypeSlugs.zusatzarbeit);
        }
        if (this.FormGroup.value.dokumentation) {
            typesToGenerate.push(GeneratedDocumentsTypeSlugs.dokumentation);
        }
        if (this.FormGroup.value.regiearbeit) {
            typesToGenerate.push(GeneratedDocumentsTypeSlugs.regiearbeit);
        }
        if (this.FormGroup.value.bedenken) {
            typesToGenerate.push(GeneratedDocumentsTypeSlugs.bedenken);
        }
        if (this.FormGroup.value.auffaelligkeiten) {
            typesToGenerate.push(GeneratedDocumentsTypeSlugs.auffaelligkeit);
        }
        if (this.FormGroup.value.mangel) {
            typesToGenerate.push(GeneratedDocumentsTypeSlugs.mangel);
        }
        if (this.FormGroup.value.erschwernis) {
            typesToGenerate.push(GeneratedDocumentsTypeSlugs.erschwernis);
        }
        const count = typesToGenerate.length;
        if (count === 0) {
            return;
        }
         this.LS.startLoading('create-diary');
        const options = getExportOptions(this.FormGroup.value);
        const exportIds: number[] = this.selection.selected.length ? this.selection.selected.map((c) => c.id): undefined;
        this.diaryService
            .generateDiary(typesToGenerate, this.DialogData.CommissionId, this.DateForm.value.toDate(), this.ToDateForm.value.toDate(), exportIds, options)
            .then((res) => {
                if (res?.length) {
                    this.generatedDocumentsResolver.pollUpdated();
                    this.dialogRef.close(res);
                }
            })
            .finally(() => this.LS.endLoading('create-diary'));
    }


    isAllSelected(data: MatTableDataSource<TableData>) {
        const numSelected = this.selection.selected.length;
        let numRows = data.data.length;
        return numSelected === numRows;
    }

    toggleAllCheckboxes(data: MatTableDataSource<TableData>) {
        if (this.isAllSelected(data)) {
            this.selection.clear();
        } else {
            this.selection.select(...data.data);
        }
    }

    protected readonly imageQualityEnum = imageQualityEnum;
}
